import { useState, useEffect } from 'react';

// Silhueta simplificada do Brasil (viewBox 304x302)
const BRAZIL = "M 75,42 L 100,35 L 130,30 L 162,28 L 195,35 L 220,52 L 242,74 L 254,100 L 250,126 L 242,152 L 234,176 L 224,198 L 214,220 L 200,242 L 182,258 L 164,268 L 148,262 L 130,248 L 110,228 L 95,208 L 80,188 L 68,168 L 62,144 L 60,118 L 64,94 L 68,70 L 72,50 Z";

// Órbita elíptica ao redor do Brasil (centro 152,150 rx=120 ry=128)
const ORBIT = "M 272,150 A 120,128 0 0,1 32,150 A 120,128 0 0,1 272,150";

function AnimatedDots() {
  const [n, setN] = useState(1);
  useEffect(() => {
    const t = setInterval(() => setN(c => (c < 3 ? c + 1 : 0)), 450);
    return () => clearInterval(t);
  }, []);
  return (
    <span style={{ display: 'inline-block', width: 22, textAlign: 'left' }}>
      {'.'.repeat(n)}
    </span>
  );
}

export function LoadingOverlay({ visible }) {
  return (
    <div
      data-testid="loading-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(240,244,255,0.94)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        transition: 'opacity 0.2s ease, visibility 0.2s ease',
        opacity: visible ? 1 : 0,
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: visible ? 'all' : 'none',
      }}
    >
      <svg
        viewBox="0 0 304 302"
        width="240"
        height="240"
        xmlns="http://www.w3.org/2000/svg"
        overflow="visible"
      >
        <defs>
          <radialGradient id="ld-bg" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#dbeafe" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#f0f4ff" stopOpacity="0" />
          </radialGradient>
          <filter id="ld-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.5" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Halo de fundo */}
        <circle cx="152" cy="150" r="148" fill="url(#ld-bg)" />

        {/* Anel tracejado da órbita */}
        <ellipse
          cx="152" cy="150" rx="120" ry="128"
          fill="none"
          stroke="#93c5fd"
          strokeWidth="1.5"
          strokeDasharray="4 6"
          strokeOpacity="0.65"
        />

        {/* Mapa do Brasil */}
        <path
          d={BRAZIL}
          fill="#0147a0"
          fillOpacity="0.10"
          stroke="#0147a0"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />

        {/* Ponto de Brasília com pulso */}
        <circle cx="150" cy="152" r="3.5" fill="#d72d21" />
        <circle cx="150" cy="152" r="3.5" fill="#d72d21" fillOpacity="0.35">
          <animate attributeName="r" values="3.5;9;3.5" dur="2.2s" repeatCount="indefinite" />
          <animate attributeName="fill-opacity" values="0.35;0;0.35" dur="2.2s" repeatCount="indefinite" />
        </circle>

        {/* Ônibus animado na órbita */}
        <g filter="url(#ld-glow)">
          <animateMotion dur="3.6s" repeatCount="indefinite" rotate="auto">
            <mpath href="#ld-orbit" />
          </animateMotion>

          {/* Carroceria */}
          <rect x="-13" y="-7" width="26" height="14" rx="3.5" fill="#0147a0" />
          <rect x="-13" y="-7" width="26" height="14" rx="3.5" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="0.8" />

          {/* Faixa lateral */}
          <rect x="-13" y="-0.5" width="26" height="2" rx="0.5" fill="rgba(255,255,255,0.14)" />

          {/* Janelas laterais */}
          <rect x="-10" y="-5.5" width="4.5" height="4.5" rx="1" fill="rgba(219,234,254,0.9)" />
          <rect x="-4" y="-5.5" width="4.5" height="4.5" rx="1" fill="rgba(219,234,254,0.9)" />
          <rect x="2" y="-5.5" width="4.5" height="4.5" rx="1" fill="rgba(219,234,254,0.9)" />

          {/* Para-brisa dianteiro (frente = direita, +x) */}
          <rect x="8" y="-5.5" width="4.5" height="4.5" rx="1" fill="rgba(186,230,253,0.95)" />

          {/* Farol com brilho */}
          <rect x="13" y="-2.5" width="2.5" height="3.5" rx="0.5" fill="#fef08a" />
          <ellipse cx="16" cy="-1" rx="5" ry="2.5" fill="#fef08a" fillOpacity="0.12" />

          {/* Rodas */}
          <circle cx="-7" cy="7" r="3.2" fill="#1e293b" />
          <circle cx="6" cy="7" r="3.2" fill="#1e293b" />
          <circle cx="-7" cy="7" r="1.4" fill="#475569" />
          <circle cx="6" cy="7" r="1.4" fill="#475569" />
        </g>

        {/* Caminho oculto para animateMotion */}
        <path id="ld-orbit" d={ORBIT} fill="none" stroke="none" />
      </svg>

      <div style={{ marginTop: -12, textAlign: 'center' }}>
        <p
          style={{
            color: '#0147a0',
            fontSize: 20,
            fontWeight: 800,
            fontFamily: 'Manrope, sans-serif',
            letterSpacing: '-0.3px',
            lineHeight: 1.2,
          }}
        >
          Carregando<AnimatedDots />
        </p>
        <p style={{ color: '#94a3b8', fontSize: 13, marginTop: 5 }}>
          Aguarde um momento
        </p>
      </div>
    </div>
  );
}
